import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-d16d6306");

_pushScopeId("data-v-d16d6306");

var _hoisted_1 = {
  class: "navbar"
};
var _hoisted_2 = {
  class: "right-menu"
};
var _hoisted_3 = {
  class: "right-menu-item hover-effect"
};

var _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "/avatar.png",
  class: "user-avatar"
}, null, -1
/* HOISTED */
);

var _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1
/* HOISTED */
);

var _hoisted_6 = {
  class: "navbar-dropdown-item"
};
var _hoisted_7 = {
  class: "dialog-footer"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("确定");

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_logo = _resolveComponent("logo");

  var _component_breadcrumb = _resolveComponent("breadcrumb");

  var _component_error_log = _resolveComponent("error-log");

  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode(_component_logo, {
    collapse: !_ctx.sidebar.opened
  }, null, 8
  /* PROPS */
  , ["collapse"]), _createVNode("div", {
    class: "siderbar-switcher",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.toggleSideBar && $setup.toggleSideBar.apply($setup, arguments);
    })
  }, [_createVNode("i", {
    class: ['iconfont', _ctx.sidebar.opened ? 'icon-outdent' : 'icon-indent']
  }, null, 2
  /* CLASS */
  )]), _createVNode(_component_breadcrumb, {
    id: "breadcrumb-container",
    class: "breadcrumb-container"
  }), _createVNode("div", _hoisted_2, [_ctx.device !== 'mobile' ? (_openBlock(), _createBlock(_Fragment, {
    key: 0
  }, [_createCommentVNode(" <search id=\"header-search\" class=\"right-menu-item\" /> "), _createVNode(_component_error_log, {
    class: "errLog-container right-menu-item hover-effect"
  }), _createCommentVNode(" <screenfull id=\"screenfull\" class=\"right-menu-item hover-effect\" /> "), _createCommentVNode(" <el-tooltip :content=\"$t('navbar.size')\" effect=\"dark\" placement=\"bottom\">\r\n          <size-select id=\"size-select\" class=\"right-menu-item hover-effect\" />\r\n        </el-tooltip>"), _createCommentVNode(" <lang-select class=\"right-menu-item hover-effect\" /> ")], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : _createCommentVNode("v-if", true), _createVNode(_component_el_dropdown, {
    class: "avatar-container"
  }, {
    dropdown: _withId(function () {
      return [_createVNode(_component_el_dropdown_menu, null, {
        default: _withId(function () {
          return [(_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.rightMenus, function (item) {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.code,
              onClick: function onClick($event) {
                return $setup.clickRightMenu(item.code);
              },
              divided: item.divided
            }, {
              default: _withId(function () {
                return [_createVNode("div", _hoisted_6, _toDisplayString(item.title), 1
                /* TEXT */
                )];
              }),
              _: 2
              /* DYNAMIC */

            }, 1032
            /* PROPS, DYNAMIC_SLOTS */
            , ["onClick", "divided"]);
          }), 128
          /* KEYED_FRAGMENT */
          ))];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    default: _withId(function () {
      return [_createVNode("div", _hoisted_3, [_hoisted_4, _createVNode("div", null, [_createTextVNode(_toDisplayString($setup.nickname) + " ", 1
      /* TEXT */
      ), _hoisted_5])])];
    }),
    _: 1
    /* STABLE */

  })]), _createVNode(_component_el_dialog, {
    "close-on-click-modal": false,
    title: "修改密码",
    modelValue: $setup.dialogChangePasswordVisible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $setup.dialogChangePasswordVisible = $event;
    }),
    "append-to-body": true,
    width: "460px"
  }, {
    default: _withId(function () {
      return [_createVNode(_component_el_form, {
        ref: "dataChangePasswordForm",
        rules: $setup.changePasswordDataRules,
        model: $setup.changePasswordData,
        "label-width": "110px",
        style: {
          "width": "320px",
          "margin-left": "30px"
        }
      }, {
        default: _withId(function () {
          return [_createVNode(_component_el_form_item, {
            label: "原始密码",
            prop: "oldPassword"
          }, {
            default: _withId(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $setup.changePasswordData.oldPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return $setup.changePasswordData.oldPassword = $event;
                }),
                maxlength: "18",
                type: "password"
              }, null, 8
              /* PROPS */
              , ["modelValue"])];
            }),
            _: 1
            /* STABLE */

          }), _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "newPassword"
          }, {
            default: _withId(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $setup.changePasswordData.newPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return $setup.changePasswordData.newPassword = $event;
                }),
                maxlength: "18",
                type: "password"
              }, null, 8
              /* PROPS */
              , ["modelValue"])];
            }),
            _: 1
            /* STABLE */

          }), _createVNode(_component_el_form_item, {
            label: "确认密码",
            prop: "newPassword2"
          }, {
            default: _withId(function () {
              return [_createVNode(_component_el_input, {
                modelValue: $setup.changePasswordData.newPassword2,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return $setup.changePasswordData.newPassword2 = $event;
                }),
                maxlength: "18",
                type: "password"
              }, null, 8
              /* PROPS */
              , ["modelValue"])];
            }),
            _: 1
            /* STABLE */

          })];
        }),
        _: 1
        /* STABLE */

      }, 8
      /* PROPS */
      , ["rules", "model"]), _createVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return $setup.dialogChangePasswordVisible = false;
        })
      }, {
        default: _withId(function () {
          return [_hoisted_8];
        }),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return $options.savePassword('dataChangePasswordForm');
        })
      }, {
        default: _withId(function () {
          return [_hoisted_9];
        }),
        _: 1
        /* STABLE */

      })])];
    }),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["modelValue"])]);
});